export const isTestEnv = ["staging", "localhost"].some((env) =>
  window.location.hostname.includes(env)
);
